module.exports = __webpack_public_path__ + "img/Weavrwise.5a845254.svg";